import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { UtilService } from '../../services/util.service';
import { MessageService } from 'primeng/components/common/messageservice';
import { CadastroAnuncioService } from 'app/anuncio/services/cadastro-anuncio.service';
import { Router } from '@angular/router';
import { OrigemEnum } from 'app/shared/enum/origem.enum';
import { AnuncioTipoEnum } from 'app/shared/enum/anuncio-tipo.enum';
import { Entidade } from 'app/anuncio/models/entidade.model';
import { AuthService } from 'app/shared/services/auth.service';

@Component({
  selector: 'alterar-empresa',
  templateUrl: './alterar-empresa.component.html',
  styleUrls: ['./alterar-empresa.component.scss']
})
export class AlterarEmpresaComponent implements OnInit {



  @Input()
  show: boolean = false;

  //evento para avisar que finalizou a análise


  //indica se deve exibir o modal de analisar interesse
  exibirModalAlterarEmpresa: boolean =  false;


  //anuncio interesse a ser analisado
  entidade: Entidade| null = null;


  listaEntidades: Entidade[] = [];
  tipoSelecionadoValue: { id: AnuncioTipoEnum, nome: string } = { id: AnuncioTipoEnum.GENERICO, nome: 'Anúncio padrão' };

  constructor(
    private formBuilder: FormBuilder,
    private utilService: UtilService,
    public authService: AuthService,
    private messageService: MessageService,
    private cadastroAnuncioService: CadastroAnuncioService,
    private router: Router,
  ) { }

  ngOnInit() {

      const entidadeNumero= this.authService.usuario.numeroEntidade;
      let entidadeDefault = this.entidadeDefault();
      this.listaEntidades = [entidadeDefault];
  }

  /**
   * Exibir modal.
   */
  abrirModalAlterarEmpresa() {
        this.authService.getEmpresasPrivadas().subscribe((empresas: Entidade[]) => {
      const entidadeNumero= this.authService.usuario.numeroEntidade;
      let entidadeDefault = this.entidadeDefault();
      this.entidade = empresas.find(e => e.numero == entidadeNumero) || entidadeDefault;
      this.listaEntidades = [entidadeDefault, ...empresas];
      this.exibirModalAlterarEmpresa = true;
    });

  }

  onCancelar() {
    this.ocultarModal();
  }

  /**
   * Ocultar modal.
   */
  ocultarModal() {
    this.exibirModalAlterarEmpresa = false;
  }

  limparEmpresa() {
    this.entidade = this.entidadeDefault();
    this.onConfirmar();
  }

  private entidadeDefault(): Entidade {
    let entidadeDefault = new Entidade(-1);
    entidadeDefault.numero ="-1";
    entidadeDefault.nome = 'PESSOA FÍSICA';
    return entidadeDefault;
  }


  public onConfirmar():void {
    if(this.entidade) {
      this.authService.changeEntidade(this.entidade).subscribe( (token: { token: string }) => {
        if( token && token.token && token.token !== '' && token.token.length > 20) {
          this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Empresa alterada com sucesso!' });
          this.authService.alterarToken(token.token);
            setTimeout(() => {
                  window.location.reload();
            }, 1000);
        } else {
          this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Empresa selecionada é a mesma já utilizada.' });
        }

      }, (error) => {
        this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Ocorreu um erro ao alterar a empresa. Tente novamente.' });
      });
    } else {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Selecione uma empresa para continuar.' });
    }
      this.ocultarModal();
  }



}
